const doctorPhoneLabel = '[data-label="Phone"]'
const doctorFaxLabel = '[data-label="Fax"]'
const doctorAddressLabel = '[data-label="Address"]'
const doctorAddress2Label = '[data-label="Address Line 2"]'
const doctorCityLabel = '[data-label="City"]'
const doctorStateLabel = '[data-label="State"]'
const doctorZipCodeLabel = '[data-label="Zip Code"]'
const addressSelectorClass = 'doctor-addresses-list'
const newAddressFlag = 'add-new'
const doctorNameLabelInput = '[data-label="Name of Doctor"] input'

const statesArray = {
  'Alabama': 'AL',
  'Alaska' : 'AK',
  'Arizona' : 'AZ',
  'Arkansas' : 'AR',
  'California' : 'CA',
  'Colorado' : 'CO',
  'Connecticut' : 'CT',
  'Delaware' : 'DE',
  'District of Columbia' : 'DC',
  'Florida' : 'FL',
  'Georgia' : 'GA',
  'Hawaii' : 'HI',
  'Idaho' : 'ID',
  'Illinois' : 'IL',
  'Indiana' : 'IN',
  'Iowa' : 'IA',
  'Kansas' : 'KS',
  'Kentucky' : 'KY',
  'Louisiana' : 'LA',
  'Maine' : 'ME',
  'Maryland' : 'MD',
  'Massachusetts' : 'MA',
  'Michigan' : 'MI',
  'Minnesota' : 'MN',
  'Mississippi' : 'MS',
  'Missouri' : 'MO',
  'Montana' : 'MT',
  'Nebraska' : 'NE',
  'Nevada' : 'NV',
  'New Hampshire' : 'NH',
  'New Jersey' : 'NJ',
  'New Mexico' : 'NM',
  'New York' : 'NY',
  'North Carolina' : 'NC',
  'North Dakota' : 'ND',
  'Ohio' : 'OH',
  'Oklahoma' : 'OK',
  'Oregon' : 'OR',
  'Pennsylvania' : 'PA',
  'Rhode Island' : 'RI',
  'South Carolina' : 'SC',
  'South Dakota' : 'SD',
  'Tennessee' : 'TN',
  'Texas' : 'TX',
  'Utah' : 'UT',
  'Vermont' : 'VT',
  'Virginia' : 'VA',
  'Washington' : 'WA',
  'West Virginia' : 'WV',
  'Wisconsin' : 'WI',
  'Wyoming' : 'WY',
  'American Samoa' : 'AS',
  'Guam' : 'GU',
  'Northern Mariana Islands' : 'MP',
  'Puerto Rico' : 'PR',
  'U.S. Virgin Islands' : 'VI',
  'United States Minor Outlying Islands' : 'UM',
  'Armed Forces Americas' : 'AA',
  'Armed Forces Europe' : 'AE',
  'Armed Forces Pacific': 'AP',
};

/**
 * Loops throught a object with {key : value} pairs and finds a dom element with
 * the form <input data-label="{key}"> and sets its value with the pair value.
 *
 * @param {object} object the data object.
 * @param {element} container the parent element that contains the inputs.
 */
function setInputValuesByObjectData( object, container ) {
  if ( Object.prototype.hasOwnProperty.call( object, 'id' ) ) {
    const apiParams = {
      'id': object.id
    }
    getDoctorAddresses( apiParams, container )
  }

  Object.keys( object ).forEach( key => {
    const field = container.querySelector( `[data-label="${ key }"] input` )
    if ( field ) {
      let inputVal = object[ key ]
      if ( key === 'state' ) {
        inputVal = convertStateCodeToStateName( inputVal )
      }

      field.value = inputVal
    }
  } )
}

/**
 * Converts a US state code to it's full name.
 *
 * @param {string} code The state code.
 * @returns {string} State full name
 */
function convertStateCodeToStateName( code ) {
  for ( const stateLong in statesArray ) {
    if ( statesArray[stateLong] === code ) {
      return stateLong;
    }
  }

  return code;
}

/**
 * Retrieve doctor's addresses.
 *
 * @param {object}  apiParams An object of API parameters.
 * @param {element} container the parent element that contains the inputs.
 */
function getDoctorAddresses( apiParams, container ) {
  $.ajax( {
    url: `${ window.mce.api_url }doctor/addresses`,
    type: 'get',
    data: apiParams,
    success: function ( data ) {
      if ( $( container ).find( `.${ addressSelectorClass }` ).length ) {
        $( container ).find( `.${ addressSelectorClass }` ).parent( 'td' ).remove()
      }

      showAddressFields( container )

      if ( data.length > 0 ) {
        displayAddressList( data, container )
      }
    }
  } )
}

/**
 * Hides Doctor Address and Zip Code td elements.
 *
 * @param {element} container the parent element that contains the inputs.
 */
function hideAddressFields( container ) {
  $( container ).find( doctorAddressLabel ).hide()
  $( container ).find( doctorZipCodeLabel ).hide()
  $( container ).find( doctorAddress2Label ).hide()
  $( container ).find( doctorCityLabel ).hide()
  $( container ).find( doctorStateLabel ).hide()
}

/**
 * Shows Doctor Address and Zip Code td elements.
 *
 * @param {element} container the parent element that contains the inputs.
 */
function showAddressFields( container ) {
  $( container ).find( doctorAddressLabel ).show()
  $( container ).find( doctorAddress2Label ).show()
  $( container ).find( doctorCityLabel ).show()
  $( container ).find( doctorStateLabel ).show()
  $( container ).find( doctorZipCodeLabel ).show()
}

/**
 * Initializes and displays doctor's addresses drop-down
 * @param {array} data A JSON data object.
 * @param {element} container the parent element that contains the inputs.
 */
function displayAddressList( data, container ) {
  const list = $( '<select />' ).addClass( `gform_multi_address ${ addressSelectorClass }` )
  const td = $( '<td data-label="Available addresses">' ).addClass( 'gfield_list_cell' )

  if ( data.length === 0 ) {
    return
  }

  for ( const index in data ) {
    const fullAddress = data[ index ][ 'value' ]

    const optionAttributes = {
      'data-address': data[ index ][ 'address_line_1' ],
      'data-address2': data[ index ][ 'address_line_2' ],
      'data-city': data[ index ][ 'city' ],
      'data-state': data[ index ][ 'state' ],
      'data-zip-code': data[ index ][ 'zip' ],
      'data-phone': data[ index ][ 'phone' ],
      'data-fax': data[ index ][ 'fax' ],
    }

    $( '<option />', { value: index, text: fullAddress } )
      .attr( optionAttributes )
      .appendTo( list )
  }

  $( '<option />', { value: newAddressFlag, text: 'Add new address' } ).appendTo( list )

  list.on( 'change', function onAddressChange() {
    selectAddress( this, container )
  } ).appendTo( td )

  // Autofill fields when the "Available addresses" field is created.
  selectAddress( list, container )

  td.insertAfter( $( container ).find( doctorNameLabelInput ).closest( 'td' ) )
}

/**
 * Auto-fill address and Zip Code on address change
 *
 * @param {element} element Address select element.
 * @param {element} container the parent element that contains the inputs.
 */
function selectAddress( element, container ) {
  $( element ).val() === newAddressFlag ? showAddressFields( container ) : hideAddressFields( container )

  const fields = {
    [ `${ doctorPhoneLabel } input` ]: 'phone',
    [ `${ doctorFaxLabel } input` ]: 'fax',
    [ `${ doctorAddressLabel } input` ]: 'address',
    [ `${ doctorAddress2Label } input` ]: 'address2',
    [ `${ doctorCityLabel } input` ]: 'city',
    [ `${ doctorStateLabel } select` ]: 'state',
    [ `${ doctorZipCodeLabel } input` ]: 'zip-code',
  }

  for ( const key in fields ) {
    const dataName = fields[ key ]
    let value = $( element ).find( ':selected' ).data( dataName )

    if ( dataName === 'state' ) {
      value = convertStateCodeToStateName( value )
    }

    // If no Select Option is selected then select the first one.
    if ( !value ) {
      value = $( element ).first().data( dataName )
    }

    $( container ).find( key ).val( value )
  }
}

/**
 * Adds autocomplete functionnality to text input exclusively for the Add Doctor sections.
 * The main container of the fields must have the class doctors.
 * Fields IDs are hardcoded. Couldn't find a better way to identify them.
 * Using this ID will allow the admin to change the label and order of this fields.
 *
 * @param {element} container the doctor box container.
 */
function addAutocomplete( container ) {
  window.mce = 'mce' in window ? window.mce : {}

  $( doctorNameLabelInput, container ).autocomplete( {
    source: function ( request, response ) {
      $.ajax( {
        url: `${ window.mce.api_url }doctors`,
        type: 'get',
        data: {
          input: request.term,

        },
        success: function ( data ) {
          response( data )
        }
      } )
    },
    minLength: 2,
    select: function ( event, ui ) {
      setInputValuesByObjectData( ui.item, container )
    }
  } )
}

/**
 * Detects when a new Doctor Box is added for binding the new autocomplete field.
 * Refer to: https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
 */
function detectDoctorAdded() {
  // Select the node that will be observed for mutations.
  const targetNode = document.querySelector( '.gfield_list tbody' )

  // Options for the observer (which mutations to observe).
  const config = { childList: true }

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver( bindNewAutocomplete )

  // Start observing the target node for configured mutations
  observer.observe( targetNode, config )

  /**
   * Bind the new doctor's name field to a jQuery Autcomplete instance.
   */
  function bindNewAutocomplete() {
    const newDoctorContainer = $( targetNode ).find( '.gfield_list_group' ).last()

    if ( newDoctorContainer.length ) {
      const element = newDoctorContainer[ 0 ]
      if ( element ) {
        addAutocomplete( element )
      }
    }
  }
}

/**
 * Adds autocomplete functionnality to text input exclusively for the Add Doctor sections.
 * The main container of the fields must have the class doctors.
 * Fields IDs are hardcoded. Couldn't find a better way to identify them.
 * Using this ID will allow the admin to change the label and order of this fields.
 */
export function addAutocompleteFieldForDoctors() {
  const $doctorContainers = $( '.doctors .gfield_list_group' )

  $.each( $doctorContainers, function autocomplete() {
    addAutocomplete( this )
  } )

  detectDoctorAdded()
}
